import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { BankAccountService } from '../bancos/bankaccount.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { consts } from '../../../consts';
import { CobroCuotasCreditosConEmpleadosModel, CreditosConEmpleadosModel } from './creditos-con-empleados.model';
import { CreditosConEmpleadosListComponent } from './creditos-con-empleados-list.component';
import { CreditosConEmpleadosService } from './creditos-con-empleados.service';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';

@Component({
    selector: 'convfact-creditosconempleadoscobrocuotas',
    templateUrl: './creditos-con-empleados-dialog-cobro-cuotas.component.html',
    styleUrls: ['./creditos-con-empleados.component.css'],
    standalone: false
})
export class CreditosConEmpleadosDialogCobroCuotasComponent implements OnInit {

  public creditosconempleados: CreditosConEmpleadosModel = this.data.creditosconempleados;

  public cobroCuotasCreditosConEmpleados: CobroCuotasCreditosConEmpleadosModel = new CobroCuotasCreditosConEmpleadosModel();

  public depositSaved: boolean = false;

  public ready: boolean = false;

  public isEditMode: boolean = false;

  public list: boolean = false;

  public bankAccounts: BankAccountModel[] = [];

  public dataSource: CobroCuotasCreditosConEmpleadosModel[] = [];
  public headerTable: any[] = [
    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },
    { field: 'importeCapital', title: 'Importe Capital', cell: (row) => `${row.importeCapital}  `, class: (row) => `` },
    { field: 'intereses', title: 'Intereses', cell: (row) => `${row.intereses}  `, class: (row) => `` },
    { field: 'bankAccountInfo', title: 'Banco / Tarjeta', cell: (row) => row.bankAccountInfo ? `${row.bankAccountInfo}` : '', class: (row) => `` },
  ];

  public invalidDate: boolean = false;
  public invalidConcept: boolean = false;
  public invalidImporteCapital: boolean = false;
  public invalidIntereses: boolean = false;
  public invalidBankAccount: boolean = false;

  public activities: ActivityModel[] = [];

  constructor(
    public dialogRef: MatDialogRef<CreditosConEmpleadosListComponent>,
    public creditosConEmpleadosService: CreditosConEmpleadosService,
    public bankAccountService: BankAccountService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public activityService: ActivityService,
  ) { }

  public ngOnInit(): void {
    this.activityService.getList()
      .then(response => {
        this.activities = response;
      });

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
      });

    this.getData();
  }

  public pay(): void {
    // Asignamos el uid de la inversion al deposito
    this.cobroCuotasCreditosConEmpleados.creditosConEmpleadosId = this.creditosconempleados.uid;

    let noError: boolean = true;

    // Validations
    if (this.cobroCuotasCreditosConEmpleados.fecha == null) {
      noError = false;
      this.invalidDate = true;
    }

    if (this.cobroCuotasCreditosConEmpleados.concepto == null || this.cobroCuotasCreditosConEmpleados.concepto == '') {
      noError = false;
      this.invalidConcept = true;
    }

    if (this.cobroCuotasCreditosConEmpleados.importeCapital == null || this.cobroCuotasCreditosConEmpleados.importeCapital == 0) {
      noError = false;
      this.invalidImporteCapital = true;
    }

    if (this.cobroCuotasCreditosConEmpleados.bankAccountsUid == null || this.cobroCuotasCreditosConEmpleados.bankAccountsUid === consts.EMPTY_GUID) {
      noError = false;
      this.invalidBankAccount = true;
    }

    if (this.cobroCuotasCreditosConEmpleados.activitiesUid == null) {
      noError = false;
    }

    // Request
    if (noError) {
      if (this.isEditMode === false) {
        this.creditosConEmpleadosService.cobroCoutasCreate(this.cobroCuotasCreditosConEmpleados)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al añadir el cobro");
          });
      }
      if (this.isEditMode === true) {
        this.creditosConEmpleadosService.cobroCoutasUpdate(this.cobroCuotasCreditosConEmpleados)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al actualizar el cobro");
          });
      }
    } else {
      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
    }

  }

  public getData(): void {
    this.depositSaved = false;
    this.ready = false;

    this.invalidDate = false;
    this.invalidConcept = false;
    this.invalidImporteCapital = false;
    this.invalidIntereses = false;
    this.invalidBankAccount = false;

    this.creditosConEmpleadosService.cobroCoutasList(this.creditosconempleados.uid)
      .then(response => {
        this.dataSource = response;

        if (this.dataSource.length > 0) {
          this.list = true;
        }
        this.ready = true;
      })
      .catch(error => {
        this.ready = true;
      });
  }

  public delete(uidElement: string): void {
    // Este uid es el id
    this.creditosConEmpleadosService.cobroCoutasDelete(uidElement)
      .then(response => {
        this.getData();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al eliminar el Cobro");
      });
  }

  public edit(uidElement: string): void {
    const elementSearched = this.dataSource.find(f => f.uid == uidElement);

    this.isEditMode = true;
    this.depositSaved = false;

    this.cobroCuotasCreditosConEmpleados = elementSearched;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
  public trackByIndex(i: number) { return i; }

}
